import { useMemo } from "react";
import { Link } from "react-router-dom";
import Table from "../../../components/Table";
import moment from "moment/moment";

const roleList = ["Admin", "Faculty", "Learner"];

const ReportsTable = (props) => {
  const { reports } = props;
  const columns = useMemo(
    () => [
      {
        id: "attemptDate",
        header: "Attempt Date",
        Header: () => <div className="table-title">ATTEMPT DATE</div>,
        accessorFn: (row) =>
          row.attemptDate
            ? moment(row.attemptDate).format("MMM DD, YYYY HH:mm")
            : "",
        filterVariant: "text",
        size: 30,
      },
      {
        header: "Name",
        Header: () => <div className="table-title">NAME</div>,
        accessorFn: (row) => (
          <Link className="link-clear" to={`./${row.idSession}`}>
            {row.mode}
          </Link>
        ),
        filterVariant: "text",
        size: 30,
      },
      {
        accessorKey: "score",
        header: "Score",
        Header: () => <div className="table-title">SCORE</div>,
        filterVariant: "text",
        size: 20,
      },
      {
        accessorKey: "duration",
        header: "Duration",
        Header: () => <div className="table-title">DURATION</div>,
        accessorFn: (row) =>
          row.duration !== undefined && row.duration !== null
            ? Math.floor(row.duration / 60) + " min"
            : "",
        filterVariant: "text",
        size: 20,
      },
    ],
    [],
  );

  return (
    <Table
      data={reports}
      height="clamp(10rem, 50vh, 40rem)"
      columns={columns}
    />
  );
};

export default ReportsTable;
